import cookie from 'webmd-cookie';

/**
 * Sets the "dmp" parameter in ad-calls with latest AAM cookie values
 * Does not ignore the previously set "dmp" values
 */

if (typeof window !== 'undefined') {
 
	let setAAM = function() {
		let aamCookie = cookie.get('aam');
		let aamid = cookie.get("aam_uuid");
		let parts;

		//PPE-324582 : Disable Vendor
  		//Disable vendor if url containts vendor=0 or aam=0
  		var url = (document.referrer) ? document.referrer : document.location.href;
		if (url && (url.indexOf('vendor=0') > -1 || url.indexOf('aam=0') > -1)) {
			return false;
		}

		//PPE-411484 don't execute on member pages
		// if we are on member page, return immediately
		if ((/member./).test(location.host)) {
			return;
		}

		// block vendor on sensitive pages 
        if (window.s_sensitive && window.s_sensitive === "true") {
            return false;
        }

		// if aam cookie is set
		if (aamCookie) {

			// if dmp key already exists in pagetargets, 
			// re-use the same dmp key for dynamic ad requests.
			// otherwise, set it
			if (window.webmd && window.webmd.ads && window.webmd.ads.pageTargets &&  !window.webmd.ads.pageTargets.dmp) {

			// aam cookie structure: "aam=999999, 999992, ..."
				parts = aamCookie.split('=');

				// if we have dmp values, set dmp in ads pagetarget
				if (parts.length > 1 && parts[1] !== '') {
					window.webmd.ads.setPageTarget('dmp', parts[1]);
				}
			}
		}

		// set aam_uuid
		if (!aamid) {
			// if aam_uuid cookie doesn't exist, set aamid to 0.
			window.webmd.ads.setPageTarget('aamid', 0);
			return;
		} else if (!window.webmd.ads.pageTargets.aamid) {
			// set aamid only if the pagetarget isn't already set
			window.webmd.ads.setPageTarget('aamid', aamid);
		}
	};
	// call the setAAM function
	setAAM();
}
